import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
// 导入代码高亮样式
import 'highlight.js/styles/github.css';

// 环境信息调试
console.log('=== 环境调试信息 ===');
console.log('User Agent:', navigator.userAgent);
console.log('当前URL:', window.location.href);
console.log('React版本:', React.version);
console.log('环境变量:', process.env.NODE_ENV);
console.log('BASE_URL:', process.env.PUBLIC_URL || '/');
console.log('=================');

// 拦截网络请求以调试静态资源加载
const originalFetch = window.fetch;
window.fetch = function(...args) {
  console.log('Fetch请求:', args[0]);
  return originalFetch.apply(this, args)
    .then(response => {
      console.log('Fetch响应:', {
        url: args[0],
        status: response.status,
        contentType: response.headers.get('content-type')
      });
      return response;
    })
    .catch(error => {
      console.error('Fetch错误:', {
        url: args[0],
        error: error.message
      });
      throw error;
    });
};

// 全局错误处理
window.addEventListener('error', (event) => {
  console.error('全局错误捕获:', {
    message: event.message,
    source: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error,
    userAgent: navigator.userAgent,
    url: window.location.href
  });
  
  // 如果是JavaScript文件加载错误，可能是静态资源问题
  if (event.filename && event.filename.includes('.js')) {
    console.error('JavaScript文件加载错误，可能是静态资源配置问题');
    console.error('尝试访问的文件:', event.filename);
  }
});

// 未处理的Promise rejection
window.addEventListener('unhandledrejection', (event) => {
  console.error('未处理的Promise rejection:', {
    reason: event.reason,
    promise: event.promise,
    userAgent: navigator.userAgent,
    url: window.location.href
  });
  // 阻止默认行为（在某些浏览器中会在控制台显示错误）
  event.preventDefault();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
